/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { ICheckoutPaymentInstrumentViewProps } from './citta-checkout-payment-instrument';

const CheckoutPaymentInstrumentView: React.FC<ICheckoutPaymentInstrumentViewProps> = ({
    paymentTabs,
    paymentTabContent,
    paymentMethod,
    processingModal
}) => (
    <div>
        <div className='row citta-payment'>
            <div className='citta-payment-selected-option'>{paymentMethod}</div>
            <div id='paymentAnchor' className='anchor' />
            {paymentTabs}
            {paymentTabContent}
        </div>
        {processingModal}
    </div>
);

export default CheckoutPaymentInstrumentView;
